import { createElement } from 'react';
import { MenuItemLink } from 'react-admin';
import HomeIcon from '@mui/icons-material/Home';
import LogoutIcon from '@mui/icons-material/PowerSettingsNew';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import { upperFirst } from 'lodash';
import { auth } from '@/auth';
import { INITIAL_URL } from '@/constants';
import { Wrapper } from './styled';
import { MenuProps } from './types';
import useController from './useController';

export const Menu = ({ onMenuClick }: MenuProps) => {
  const { resourceArray, currentPath, showResources } = useController();

  return (
    <Wrapper className="main-menu" show={showResources}>
      <MenuItemLink to="/" primaryText="Home" leftIcon={<HomeIcon />} />

      {resourceArray?.map((resource, key) =>
        resource?.hasList ? (
          <MenuItemLink
            key={key}
            data-type="resource"
            to={`/${resource.name}`}
            primaryText={upperFirst(resource.options?.label || resource.name)}
            leftIcon={resource.icon ? createElement(resource.icon) : null}
            onClick={onMenuClick}
          />
        ) : null
      )}

      <MenuItemLink
        id="back-to-mordor"
        leftIcon={<RemoveRedEyeIcon />}
        onClick={() => window.open(`${import.meta.env.VITE_OLD_TURN_ADMIN_BASE_URL}${currentPath}`, '_blank')}
        primaryText="Back to Mordor"
        to={currentPath}
      />

      <MenuItemLink
        to="/"
        primaryText="Logout"
        leftIcon={<LogoutIcon />}
        onClick={() => {
          localStorage.removeItem(INITIAL_URL);
          auth.logout();
        }}
      />
    </Wrapper>
  );
};

export default Menu;
